export enum FieldRelationKind {
    HAS_MANY = 0,
    BELONGS_TO = 1,
    HAS_ONE = 2
}